import PropTypes from 'prop-types';
import React from 'react';
import Backdrop from 'root/components/molecules/Backdrop';

import {
  StyledActionButton,
  StyledButtonWrapper,
  StyledConfirmCancelButton,
  StyledConfirmMenu,
  StyledConfirmSubtitle,
  StyledConfirmTitle,
} from './styles';

const ConfirmMenu = ({
  className,
  onCancel,
  onActionButton,
  transition,
  title,
  subtitle,
  actionButtonTitle,
  targetRef,
  showOnMobile,
  ...props
}) => {
  return (
    <>
      <Backdrop onClick={onCancel} />
      <StyledConfirmMenu
        className={className}
        showOnMobile={showOnMobile}
        targetRef={targetRef}
        transition={transition}
        {...props}
      >
        {title && <StyledConfirmTitle>{title}</StyledConfirmTitle>}
        {subtitle && <StyledConfirmSubtitle>{subtitle}</StyledConfirmSubtitle>}
        <StyledButtonWrapper>
          <StyledConfirmCancelButton
            data-test-id="671f0b43-e0b6-47eb-89b0-1c8e5f5c7a35"
            onClick={onCancel}
            variant="empty"
          >
            Cancel
          </StyledConfirmCancelButton>
          <StyledActionButton
            className="desktopConfirmActionButton"
            data-test-id="46d0efab-06d5-4461-a1d3-bbbe7dde79b2"
            onClick={onActionButton}
          >
            {actionButtonTitle}
          </StyledActionButton>
        </StyledButtonWrapper>
      </StyledConfirmMenu>
    </>
  );
};

ConfirmMenu.propTypes = {
  actionButtonTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.node,
  ]),
  className: PropTypes.string,
  onActionButton: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  showOnMobile: PropTypes.bool,
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.node,
  ]),
  targetRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  title: PropTypes.string,
  transition: PropTypes.string.isRequired,
};

ConfirmMenu.defaultProps = {
  actionButtonTitle: 'Delete',
  className: '',
  showOnMobile: false,
  subtitle: 'Are you sure you want to delete?',
  targetRef: null,
  title: 'Delete',
};

export default ConfirmMenu;
